import { Button, Grid, RadioGroup, Typography, Radio } from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { numberToEuro } from '../../../reusableUtils/Helpers'
import { useReadonly } from '../../../reusableUtils/useReadonly'
import { color } from '../../../theme'
import rootStore from '../../../stores/rootStore'
import { getCurrencySymbolByCountry } from '../../../reusableUtils/currency'
import { ReactComponent as CheckedIcon } from '../../../assets/icons/checked_icon.svg'
import { useStrings } from '../../../assets/localization/strings'

export type IRadioCardGroupOption = { title: string; value?: number | string | boolean; description: string; price?: number; image: string | undefined }

type Props<T = number | string | boolean> = { name: string; defaultValue?: T; options: IRadioCardGroupOption[]; md?: number; additionalPrice?: boolean }
const ReactHookFormRadioCardGroup = ({ name, defaultValue, options, md = 6, additionalPrice = true }: Props) => {
  const strings = useStrings()
  const isReadonly = useReadonly(name)
  const { control, setValue } = useFormContext()

  const value = useWatch({ control, name })

  const renderPrice = (o: IRadioCardGroupOption, selected: boolean, inTitle = false) => {
    if (o.price == null) return null
    const position = !inTitle ? { position: 'absolute', bottom: 9, right: 9 } : {}
    const currencySymbol = rootStore.brandStore.selectedBrand?.brandCountry ? getCurrencySymbolByCountry(rootStore.brandStore.selectedBrand?.brandCountry) : '€'
    const formatPrice = (price: number, currency: string) => {
      return currency === '£'
        ? `${currency}${numberToEuro(price)}` // Pound (£) before the price
        : `${numberToEuro(price)}${currency}` // Other currencies after the price
    }

    return (
      <Grid item textAlign='right'>
        <Typography sx={{ fontSize: inTitle ? '16px' : '24px', fontWeight: 600 }} display='inline'>
          {`${additionalPrice ? '+' : ''} ${formatPrice(o.price, currencySymbol)}`}
        </Typography>
      </Grid>
    )
  }
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <RadioGroup {...field} onChange={() => { }}>
          <Grid container spacing={6}>
            {options.map(o => {
              const selected = o.value == value
              return (
                <Grid item key={`${o.value}`} xs={12} sm={6} md={md}>
                  <Button
                    sx={{
                      border: '1.5px solid',
                      borderColor: selected ? '#AB95FF' : color.grey3,
                      borderRadius: '10px',
                      textTransform: 'none',
                      padding: '20px',
                      height: '100%',
                      width: '100%',
                      alignItems: 'felx-start',
                      position: 'relative',
                      background: selected ? '#AB95FF1A' : 'inherit'
                    }}
                    value={`${o.value}`}
                    onClick={() => setValue(name, o.value)}
                    disabled={isReadonly}>
                    <Radio checked={selected} checkedIcon={<CheckedIcon />} value={o.value} sx={{ position: 'absolute', right: '0px', top: '0px' }} />
                    <Grid container>
                      {o.image && <img src={o.image} alt='type image' width={240} height={240} style={{ paddingTop: 0, borderRadius: '10px' }} />}
                      <Grid container sx={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
                        <Grid item xs={12} sx={{ fontSize: '18px', fontWeight: 600, color: '#190851', textAlign: 'left', height: '70px' }}>
                          {o.title}
                        </Grid>
                      </Grid>
                      <Grid container sx={{ display: 'flex', flexDirection: 'row' }}>
                        <Grid item sx={{ fontSize: '12px', fontWeight: 400, color: color.grey2, textAlign: 'left', width: name !== 'productType' ? '50%' : '90%' }}>
                          {o.description}
                        </Grid>
                        {/* {renderPrice(o, false)} */}

                        {name !== 'productType' && (
                          <div style={{ display: 'flex', flexDirection: 'row', width: '50%' }}>
                            <div style={{ borderStyle: 'solid', borderColor: '#17181B40', borderWidth: '0.5px', height: '95%', marginLeft: '8px', marginRight: '8px' }} />
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'left' }}>
                              <label style={{ fontSize: '14px', fontWeight: 400, color: '#17181B' }}>{strings.price}</label>
                              <span>{renderPrice(o, false)}</span>
                            </div>
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  </Button>
                </Grid>
              )
            })}
          </Grid>
        </RadioGroup>
      )}
    />
  )
}

export default ReactHookFormRadioCardGroup
